import { createContext, useContext } from 'react';
import { ModalVariant } from '../components/modal/modal.constants';
import { OpenModalOptions } from '../modal-provider';

export const ModalContext = createContext({
  openModal: (openModalOptions: OpenModalOptions) => {},
});

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
